/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取娱伯牙评分内容
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  businessId: string,
  businessType: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.productScoreRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/yby/score/${businessType}/${businessId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
